import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { Account } from "src/app/models/Account";
import { environment } from "src/environments/environment";

import ApiVersionConstants from "../constants/api-version-constants";
import { User } from "../models/User";
import { UserWithEmailAndFam } from "../models/UserWithEmailAndFam";

@Injectable({
  providedIn: "root",
})
export class PendingUserService {
  private baseUrl = `${environment.apiConfig.uri}/${ApiVersionConstants.V_2}/pendingUser`;

  constructor(private http: HttpClient) {}

  getList() {
    return this.http.get<Account[]>(this.baseUrl);
  }

  public get(id: number): Observable<User> {
    return this.http.get<User>(this.baseUrl + "/" + id).pipe(map((x) => new User().deserialize(x)));
  }

  remove(id: number) {
    return this.http.put<number>(this.baseUrl + "/" + id, {});
  }

  userExists(user: UserWithEmailAndFam): Observable<boolean> {
    return this.http.patch<boolean>(`${this.baseUrl}/userExists`, user);
  }

  requestAccount(user: Account): Observable<string> {
    return this.http.post<string>(this.baseUrl + "/requestAccount", user);
  }
}
